angular
  .module('jrUtil', ['ipCookie', 'jrConfig', 'jrCommonService'])
  .filter('encodeUri', [
    '$window',
    function ($window) {
      return function (value) {
        return angular.isDefined(value) ? $window.encodeURIComponent(value) : '';
      };
    },
  ])
  .filter('replaceParametric', function () {
    const placeholderRegex = /\$(\d)/g;
    return function (input, replacements) {
      return input.replace(placeholderRegex, function (match, p1) {
        return replacements[p1 - 1] !== undefined ? replacements[p1 - 1] : '';
      });
    };
  })
  .filter('capitalize', function () {
    return function (input) {
      return input
        ? input.replace(/([\w\u00C0-\u017F_]+[^\s-]*) */g, function (txt) {
            return txt.charAt(0).toUpperCase() + txt.substr(1).toLowerCase();
          })
        : '';
    };
  })
  .filter('searchFormatter', [
    'SearchDistanceConfig',
    '$filter',
    function (SearchDistanceConfig, $filter) {
      return function (input, bold) {
        if (input !== undefined) {
          let output = '';
          const where = input.rewrittenWhere || input.where;
          if (input.what) {
            output = $filter('capitalize')(input.what);
          }
          if (where) {
            output += (input.what ? ' / ' : '') + $filter('capitalize')(where);
          }
          if (canShowDistance(input)) {
            output += ` (${input.distance.text})`;
          }

          if (bold) {
            output = `<strong class="search-formatted">${output}</strong>`;
          }
          return output;
        }
      };

      function canShowDistance(input) {
        return (
          SearchDistanceConfig.enabled &&
          (!!input.rewrittenWhere || !!input.where) &&
          typeof input.distance !== 'undefined' &&
          !input.distance.autoexpanded &&
          input.distance.text &&
          input.distance.value !== SearchDistanceConfig.autoDistanceText
        );
      }
    },
  ])
  .filter('searchUrlFormatter', [
    'SearchDistanceConfig',
    'SearchConfig',
    'SearchFormService',
    function (SearchDistanceConfig, SearchConfig, SearchFormService) {
      return function (input) {
        if (input !== undefined) {
          const output = [];
          const hasDistanceDefined = input.distance !== undefined && input.distance.value !== '';

          if (input.what) {
            output.push(`w=${encodeURIComponent(input.what).toLocaleLowerCase()}`);
          }
          if (input.where) {
            output.push(`l=${encodeURIComponent(input.where).toLocaleLowerCase()}`);
            if (!SearchDistanceConfig.enabled) {
              output.push('r=');
            } else if (hasDistanceDefined) {
              output.push(
                input.distance.autoexpanded
                  ? `r=auto&ae=${input.distance.value}`
                  : `r=${input.distance.value}`
              );
            } else {
              output.push(`r=${SearchDistanceConfig.autoDistanceText}`);
            }
          }

          if (SearchFormService.search.sortBy) {
            output.push(`sortby=${SearchFormService.search.sortBy}`);
          }

          if (SearchConfig.showMode) {
            output.push(`shm=${SearchConfig.showMode}`);
          }

          return `/${output.length > 0 ? '?' : ''}${output.join('&')}`;
        }
      };
    },
  ])
  .factory('NavigationService', [
    '$window',
    '$filter',
    function ($window, $filter) {
      function toCountry(country) {
        $window.location.href = `https://${country.toLowerCase()}.jobrapido.com`;
      }

      function toSearch(search) {
        $window.location.href = $filter('searchUrlFormatter')(search);
      }

      function removeQueryStringParameter(key, url) {
        if (!url) {
          url = window.location.href;
        }

        const hashParts = url.split('#');
        const regex = new RegExp(`([?&])${key}=.*?(&|#|$)`, 'i');

        if (hashParts[0].match(regex)) {
          url = hashParts[0].replace(regex, '$1');
          url = url.replace(/([?&])$/, '');

          if (typeof hashParts[1] !== 'undefined' && hashParts[1] !== null) {
            url += `#${hashParts[1]}`;
          }
        }

        return url;
      }

      return {
        toCountry,
        toSearch,
        removeQueryStringParameter,
      };
    },
  ])
  .filter('emailDomainMatch', [
    'emailFormatterService',
    function (emailFormatterService) {
      function extractValue(value) {
        return !!value && emailFormatterService.hasDomainSeparator(value)
          ? emailFormatterService.getDomain(value)
          : undefined;
      }

      return function (items, value, minLength) {
        const filtered = [];
        const extractedValue = extractValue(value);
        if (!!extractedValue && extractedValue.length >= minLength) {
          angular.forEach(items, function (item) {
            if (
              new RegExp(`^${extractedValue}`).test(item.pattern.replace(/@/g, '')) ||
              (minLength < 0 && item.pattern === extractedValue)
            ) {
              filtered.push(item);
            }
          });
        }
        return filtered;
      };
    },
  ])
  .factory('emailFormatterService', [
    'jrEmailConstants',
    function (jce) {
      return {
        getDomain(value) {
          if (!angular.isDefined(value)) {
            return '';
          }
          return value.indexOf(jce.domainSeparator) !== -1
            ? value.substring(value.indexOf(jce.domainSeparator) + 1)
            : value;
        },
        getUser(value) {
          if (!angular.isDefined(value)) {
            return '';
          }
          return value.indexOf(jce.domainSeparator) !== -1
            ? value.substring(0, value.indexOf(jce.domainSeparator))
            : value;
        },
        hasDomainSeparator(value) {
          if (!angular.isDefined(value)) {
            return false;
          }
          return value.indexOf(jce.domainSeparator) !== -1;
        },
      };
    },
  ])
  .factory('OpenTabService', [
    '$window',
    'IEDetectionService',
    function ($window, IEDetectionService) {
      return {
        open(url, target) {
          if (IEDetectionService.detectIE()) {
            const link = document.createElement('a');
            link.href = url;
            document.body.appendChild(link);
            link.target = angular.isDefined(target) ? target : '_blank';
            link.click();
          } else {
            $window.open(url, angular.isDefined(target) ? target : '_blank');
          }
        },
      };
    },
  ])
  .factory('onboardingTooltipService', [
    'OnboardingTooltipConstants',
    'ipCookie',
    '$rootScope',
    function (OnboardingTooltipConstants, ipCookie, $rootScope) {
      const oldCookie = {};
      let cookie = ipCookie(OnboardingTooltipConstants.name);
      if (cookie === undefined) {
        cookie = {};
      }
      angular.copy(cookie, oldCookie);

      $rootScope.$watch(function () {
        if (!angular.equals(cookie, oldCookie)) {
          ipCookie(OnboardingTooltipConstants.name, cookie, {
            expires: 8760,
            expirationUnit: 'hours',
          });
          angular.copy(cookie, oldCookie);
        }
      });

      return {
        cookie,
      };
    },
  ])
  .factory('PasswordService', function () {
    function hideShowPassword(inputType) {
      if (inputType === 'password') {
        inputType = 'text';
      } else {
        inputType = 'password';
      }

      return inputType;
    }

    return {
      hideShowPassword,
    };
  })
  .factory('IEDetectionService', function () {
    function detectIE() {
      const ua = window.navigator.userAgent;

      const msie = ua.indexOf('MSIE ');
      if (msie > 0) {
        // IE 10 or older => return version number
        return parseInt(ua.substring(msie + 5, ua.indexOf('.', msie)), 10);
      }

      const trident = ua.indexOf('Trident/');
      if (trident > 0) {
        // IE 11 => return version number
        const rv = ua.indexOf('rv:');
        return parseInt(ua.substring(rv + 3, ua.indexOf('.', rv)), 10);
      }

      const edge = ua.indexOf('Edge/');
      if (edge > 0) {
        // Edge (IE 12+) => return version number
        return parseInt(ua.substring(edge + 5, ua.indexOf('.', edge)), 10);
      }
      return false;
    }

    return {
      detectIE,
    };
  })
  .filter('heuristicsTextParser', function () {
    return function (text) {
      return text
        .split(/(?:\.\s)+\b/gm)
        .map(function (partialText) {
          return `<p>${partialText}</p>`;
        })
        .join('');
    };
  })
  .factory('ReferrerService', function () {
    function isUserComingFromSerp(referrer, pageUrl) {
      return /jobrapido.com/i.test(referrer) && referrer !== pageUrl;
    }

    return {
      isUserComingFromSerp,
    };
  });
